import {computed, inject, Injectable, signal} from '@angular/core';
import {NavItem} from './sidebar-nav-items.model';
import {TicketNoCategoryService} from '../../../../../features/tickets/dialogs/no-category/ticket-no-category.service';
import {Router} from '@angular/router';
import {PermissionService} from '../../../../auth/services/permission.service';
import {ROLES_CONFIG, ROLES_DASHBOARD, ROLES_TICKETS, ROLES_USERS} from '../../../../auth/models/user.models';
import {MailboxDialogService} from '../../../../../features/mailbox-configurator/services/mailbox-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarNavService {
	private permission = inject(PermissionService)
	private router = inject(Router)
	private noCategoryService = inject(TicketNoCategoryService)
	private mailboxDialogService = inject(MailboxDialogService)

	openByKey(key: 'dashboard' | 'no-category' | 'support' | 'other' | 'users' | 'mailbox-configurator') {
		switch (key) {
			case 'dashboard':
				this.router.navigate(['/dashboard']);
				break;
			case 'no-category':
				this.noCategoryService.openNoCategoryDialog();
				break;
			case 'support':
				this.router.navigate(['/tickets/supporto']);
				break;
			case 'other':
				this.router.navigate(['/tickets/altro']);
				break;
			case 'users':
				this.router.navigate(['/utenti']);
				break;
			case 'mailbox-configurator':
				this.mailboxDialogService.openMailboxDialog();
				break;
		}
	}

	private menuItems = signal<NavItem[]>([
		{
			label: 'Dashboard',
			icon: 'pi pi-gauge',
			route: '/dashboard',
			roles: ROLES_DASHBOARD,
			isActive: () => this.router.url === '/'
		},
		{
			label: 'Non Categorizzati',
			icon: 'pi pi-question',
			route: null,
			roles: ROLES_TICKETS,
			command: () => this.noCategoryService.openNoCategoryDialog(),
			isActive: () => this.noCategoryService.isOpen()
		},
		{
			label: 'Supporto',
			icon: 'pi pi-wrench',
			route: '/tickets/supporto',
			roles: ROLES_TICKETS,
			isActive: () => this.router.url.startsWith('/tickets/supporto')
		},
		{
			label: 'Altro',
			icon: 'pi pi-ticket',
			route: '/tickets/altro',
			roles: ROLES_TICKETS,
			isActive: () => this.router.url.startsWith('/tickets/altro')
		},
		{
			label: 'Utenti',
			icon: 'pi pi-users',
			route: '/utenti',
			roles: ROLES_USERS,
			isActive: () => this.router.url.startsWith('/utenti')
		},
		{
			label: 'Configurazione',
			icon: 'pi pi-cog',
			route: null,
			roles: ROLES_CONFIG,
			command: () => this.mailboxDialogService.openMailboxDialog(),
			isActive: () => this.mailboxDialogService.isOpen()
		}
	]);

	readonly visibleMenuItems = computed(() =>
		this.menuItems().filter(item => this.permission.canAccess(item.roles))
	);
}
